import { groupLabel } from "../protocol";
import type { GroupEntry } from "../hooks/useGroups";

/** A quick-nav strip shown inside an open session's chat: the #Group-chat channels this session participates
 *  in, so the user can jump straight from a session to a group it's part of. Hidden when there are none. */
export function SessionGroupsBar({ groups, onOpenGroup }: { groups: GroupEntry[]; onOpenGroup: (key: string) => void }) {
  if (groups.length === 0) return null;
  return (
    <div className="session-groups-bar">
      <span className="session-groups-label">Groups</span>
      {groups.map((g) => (
        <button key={`${g.pairingId}/${g.group.id}`} className="session-group-chip" onClick={() => onOpenGroup(`${g.pairingId}/${g.group.id}`)}>
          👥 {groupLabel(g.group)}
        </button>
      ))}
    </div>
  );
}
